module.exports = __webpack_public_path__ + "d93c8a9829b5dcc28486af438894286c.png";